import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { CONSTANTS, STRINGS } from 'src/commons';
import { StyledButton, StyledTextField } from './style';
import { sendMessageToMember } from 'src/api/member';
import Alert from 'src/components/Alert';
import Snackbar from '@mui/material/Snackbar';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';

const AddMessage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user } = useSelector((state) => state.common);
  const [message, setMessage] = useState('');
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  const handleMessageChange = ({ target: { value } }) => {
    setMessage(value);
  };

  const handleSendMessage = () => {
    dispatch(startLoading());
    sendMessageToMember(user, {
      member_ids: user?._id,
      message_text: message
    })
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) {
          dispatch(logoutUser());
          return navigate(CONSTANTS.ROUTES.PUBLIC_ROUTES.LOGIN);
        }
        const isError = res.status !== CONSTANTS.STATUS_CODES.SUCCESS;
        setSnackbarState({
          open: true,
          message: !isError ? "Mesage send successfully" : res.message,
          severity: isError ? 'error' : 'success'
        });
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          setMessage('')
          return navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.MESSAGE);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
  };

  return (
    <>
      <Helmet>
        <title>Send Message | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ mb: 3 }}>
            <Typography color="textPrimary" variant="h2">
              {STRINGS.ADD_MESSAGE}
            </Typography>
          </Box>
          <Box sx={{ pt: 3, '& .MuiTextField-root': { m: 1, width: '250ch' } }}>
            <StyledTextField
              id="outlined-multiline-static"
              label="Message"
              multiline
              style={{
                display: 'block'
              }}
              value={message}
              onChange={handleMessageChange}
              rows={4}
            />
            <StyledButton
              color="primary"
              disabled={!message}
              size="large"
              variant="contained"
              onClick={handleSendMessage}
            >
              {STRINGS.SEND}
            </StyledButton>
          </Box>
        </Container>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
    </>
  );
};

export default AddMessage;
